import React, { useEffect, useRef } from 'react';
import { Warning } from '@mui/icons-material';

interface ValidationMessageProps {
  isVisible: boolean;
  errorMessage?: string;
}

const ValidationMessage: React.FC<ValidationMessageProps> = ({ isVisible, errorMessage }) => {
  const messageRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (messageRef.current) {
      if (isVisible) {
        // Slide up animation
        messageRef.current.style.transform = 'translateY(0)';
        messageRef.current.style.opacity = '1';
      } else {
        // Hide immediately (no slide animation)
        messageRef.current.style.transform = 'translateY(100%)';
        messageRef.current.style.opacity = '0';
      }
    }
  }, [isVisible]);

  return (
    <div 
      ref={messageRef}
      style={{
        transform: 'translateY(100%)',
        backgroundColor: '#fff8e1',
        border: '1px solid #ffb74d',
        color: '#e65100',
        padding: '12px 16px',
        borderRadius: '8px',
        display: 'flex',
        alignItems: 'center',
        gap: '12px',
        fontSize: '14px',
        lineHeight: '1.4',
        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.15)',
        marginBottom: '8px',
        opacity: '0',
        transition: 'transform 0.3s ease-out, opacity 0.3s ease-out',
        pointerEvents: isVisible ? 'auto' : 'none'
      }}
    >
      <Warning style={{ fontSize: '20px', flexShrink: 0, color: '#ff9800' }} />
      <div style={{ flex: 1 }}>
        {errorMessage || 'Validation error occurred'}
      </div>
    </div>
  );
};

export default ValidationMessage; 